module.exports = __webpack_public_path__ + "28b67065/img/trash-icon.ff8201c7.svg";